import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import planService from "../../services/planService";

// Queries
export const useGetPlan = (queryOptions = {}) => {
  return useQuery(["plan"], planService.show, queryOptions);
};

export const useEditPlan = (queryOptions = {}) => {
  return useQuery(["plan", "edit"], planService.edit, queryOptions);
};

// Mutations
export const useUpdatePlan = (mutationOptions = {}) => {
  // const queryClient = useQueryClient();
  return useMutation(planService.update, {
    ...mutationOptions,
    // onSuccess: (data) => {
    //   queryClient.setQueryData(["plan"], data);
    //   mutationOptions.onSuccess(data);
    // },
  });
};

export const useConfirmPlan = (mutationOptions = {}) => {
  // const queryClient = useQueryClient();
  return useMutation(planService.confirm, mutationOptions);
};
